import NavigationRouter from "@frog/source/utility/NavigationRouter.js"
import UserError from "@frog/source/utility/UserError.js"

import games from "@frog/source/data/games/index.js"
import tests from "@frog/source/tests/testlist.js"

import App from "@frog/source/models/App.js"
import Dev from "@frog/source/models/admin/Dev.js"
import Audiomix from "@frog/source/juice/Audiomix.js"
import Director from "@frog/source/juice/Director.js"
import Testlaunch from "@frog/source/tests/utility/Testlaunch.js"

const DEFAULT_GAME_SLUG = "dungeon"
const STARTING_STATE = {
    "screen": "TitleScreen",
    "gameSlug": DEFAULT_GAME_SLUG,
}

const Navigation = new NavigationRouter(STARTING_STATE)
export default Navigation

window.frog = window.frog || {}
window.frog.navigation = Navigation

//////////////////
// GAME ROUTES //
////////////////

Navigation.on("/title", function(request) {
    const gameSlug = DEFAULT_GAME_SLUG
    const game = games[gameSlug]
    if(game == undefined) {
        throw new UserError("Could not find game:", gameSlug)
    }

    Audiomix.trigger("Music:Title")
    Navigation.state = {"screen": "TitleScreen", "gameSlug": gameSlug, "isSplashing": false}
})

Navigation.on("/games/:gameSlug", function(request) {
    const gameSlug = request.wildcards.gameSlug
    const game = games[gameSlug]
    if(game == undefined) {
        throw new UserError("Could not find game:", gameSlug)
    }

    Audiomix.trigger("Music:Title")
    Navigation.state = {"screen": "TitleScreen", "gameSlug": gameSlug}
})

Navigation.on("/games/:gameSlug/title", function(request) {
    const gameSlug = request.wildcards.gameSlug
    const game = games[gameSlug]
    if(game == undefined) {
        throw new UserError("Could not find game:", gameSlug)
    }

    Audiomix.trigger("Music:Title")
    Navigation.state = {"screen": "TitleScreen", "gameSlug": gameSlug, "isSplashing": false}
})

Navigation.on("/games/:gameSlug/chapters/:chapterSlug", function(request) {
    const slug = request.wildcards.chapterSlug
    const gameslug = request.wildcards.gameSlug
    const game = games[gameslug]
    if(game == undefined) {
        throw new UserError("Could not find game:", gameslug)
    }

    const chapter = game.chapters[slug]
    if(chapter == undefined) {
        throw new UserError("Could not find chapter:", slug)
    }

    App.load({"game": {...game, chapter}})

    Navigation.state = {"screen": "ChapterScreen"}
})

Navigation.on("/games/:gameSlug/chapters/:chapterSlug/encounters/:encounterSlug", function(request) {
    const slug = request.wildcards.chapterSlug
    const gameslug = request.wildcards.gameSlug
    const game = games[gameslug]
    const chapter = game.chapters[slug]

    if(chapter == undefined) {
        throw new UserError("Could not find chapter:", slug)
    }

    App.load({"game": {...game, chapter}})
    App.game.chapter.stage.currentEncounter = request.wildcards.encounterSlug

    Navigation.state = {"screen": "ChapterScreen"}
})

Navigation.on("/credits", function(request) {
    Audiomix.trigger("Music:Credits")
    Navigation.state = {"screen": "CreditsScreen"}
})

/////////////////
// DEV ROUTES //
///////////////

Navigation.on("/dev", function(request) {
    Navigation.state = {"screen": "DevHellScreen"}
})

Navigation.on("/dev/tests", function(request) {
    Testlaunch.perform(tests)
    Navigation.state = {"screen": "DevTestListScreen"}
})

Navigation.on("/dev/tests/:testslug", function(request) {
    const testslug = request.wildcards.testslug
    const test = tests.find((test) => test.slug == testslug)
    if(test == undefined) {
        throw new UserError("Could not find test " + testslug)
    }
    Testlaunch.perform(test)
    Navigation.state = {"screen": "DevTestScreen", "test": test}
})

Navigation.on("/dev/audio", function(request) {
    Navigation.state = {"screen": "DevAudioListScreen"}
})

Navigation.on("/dev/experiment", function(request) {
    Navigation.state = {"screen": "DevExperimentScreen"}
})

Navigation.on("/dev/units", function(request) {
    Navigation.state = {"screen": "DevUnitListScreen"}
})

Navigation.on("/dev/chapters", function(request) {
    Navigation.state = {"screen": "DevChapterListScreen"}
})

Navigation.on("/dev/leveleditor", function(request) {
    this.areDevPanelsOpen = true
    this.inProtoMode = true
    Navigation.state = {"screen": "LevelEditorScreen"}
})

//////////////////
// MISC ROUTES //
////////////////

Navigation.on("/screens/:screenName", function(request) {
    Navigation.state = {"screen": request.wildcards.screenName}
})

Navigation.on("/*", function(request) {
    throw new UserError("Could not find " + request.path)
})

Navigation.onUserError = function(request) {
    Navigation.state = {"screen": "ErrorScreen", "message": request.error.message}
}
Navigation.onError = function(request) {
    Navigation.state = {"screen": "ErrorScreen", "message": "Something went wrong!!"}
}
